import { ApiUrls } from '@/common/domain/Endpoints.domain';
import instance from '@/common/service/api/Axios';
import { TPayload } from '@/screens/CheckoutPage/domain/CheckoutPage.domain';
import { TPayResponse } from '../domain/Checkout.domain';

export const postPay = async (payload: TPayload): Promise<TPayResponse> => {
    return instance.post<TPayResponse>(ApiUrls.checkout.pay, payload).then(({ data }) => data);
};
